// extracted by mini-css-extract-plugin
export default {"NothingFoundContainer":"NothingFoundText_NothingFoundContainer__hvYBZ","Center":"NothingFoundText_Center__bX5zy"};